<div
  class="panel_icon-close--left"
  (click)="onCloseClick()">
  <fa-icon [icon]="['fal', 'times']"></fa-icon>
</div>

<div 
  class="panel_title"
  [innerHTML]="item.article?.title || 'Untitled'">
</div>
<div class="list-item_author-box padding-bottom-xs">
  <ng-container *ngIf="!!item.article?.authors?.length">
    <div 
      *ngFor="let author of item.article.authors"
      class="list-item_author">
      {{ item.import_data?.source === 'janssen_endnote' ? author : (author | formatAuthor) }}
    </div>
  </ng-container>
</div>
<div class="list-item_journal-box">
  {{ item.article?.journal }} | {{ item.article?.month }} {{ item.article?.year }}
</div>
<div *ngIf="item.ext_ids?.doi">
  DOI: {{ item.ext_ids.doi}}
</div>
<div class="panel_button-box">
  <div 
    *ngIf="isLibraryItemWithPdf || isGlobalItemWithDoi"
    class="button-primary button-primary--sm"
    (click)="onViewArticleClick()">
    View article
  </div>
  <div 
    *ngIf="item.collection_id"
    class="button-primary button-primary--sm"
    (click)="urlService.editReference(item)">
    Edit article
  </div>
</div>
<div *ngIf="item.article?.abstract" class="list-item_content">
  {{ item.article?.abstract }} 
</div>